import { TranslationEntry } from '@longy/common'

import { useLocale } from '../../hooks/useLocale'

interface PackageCardProps {
    name: TranslationEntry
    description: TranslationEntry
    imageUrl?: string
}

export const PackageCard = ({ name, description, imageUrl }: PackageCardProps) => {
    const { getLocalizedValue } = useLocale()

    return (
        <div className="group overflow-hidden rounded-3xl border border-slate-100 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
            <div className="relative h-72 overflow-hidden">
                <div
                    className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
                    style={{
                        backgroundImage: `url("${
                            imageUrl ||
                            'https://images.unsplash.com/photo-1505576399279-565b52d4ac71?w=800&q=80'
                        }")`,
                    }}
                />
            </div>
            <div className="p-8">
                <div className="mb-4 flex items-start justify-between">
                    <h3 className="text-xl font-bold text-brand-dark">{getLocalizedValue(name)}</h3>
                </div>
                <p className="mb-8 text-sm leading-relaxed text-brand-gray">
                    {getLocalizedValue(description)}
                </p>
            </div>
        </div>
    )
}
